// extracted by mini-css-extract-plugin
module.exports = {"emptyListContainer":"location_emptyListContainer__3rKKb"};